import { useState } from 'react';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { Box, IconButton, Tooltip } from '@mui/material';
import { SxProps } from '@mui/system';

import { ConfirmModal } from 'components/modal';

interface RemoveOpcaoBtnProps {
    id: number;
    sx?: SxProps;
    removeBtnAction: () => void;
    editBtnAction: () => void;
}

export function RemoveEditOpcaoBtn({ id, sx, removeBtnAction = () => {}, editBtnAction = () => {} }: RemoveOpcaoBtnProps) {
    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    const callbackExcluir = (): void => {
        removeBtnAction();
        setOpenConfirmModal(false);
    };

    return (
        <>
            <Box sx={{ display: 'flex', ...sx }}>
                <Tooltip title="Editar">
                    <IconButton sx={{ p: 0.5 }} onClick={editBtnAction}>
                        <ModeEditOutlineOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Remover">
                    <IconButton sx={{ p: 0.5 }} onClick={() => setOpenConfirmModal(true)}>
                        <DeleteOutlineOutlinedIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <ConfirmModal open={openConfirmModal} setOpen={setOpenConfirmModal} confirm={callbackExcluir} />
        </>
    );
}
